const initSlider = (event, id) => {
    const slider = $(`.js-object-card[data-id="${id}"] .js-slider`)
    if(slider.length) {
        new Swiper(slider[0], {
            wrapperClass: 'js-slider-wrapper',
            slideClass: 'js-slider-slide',
            pagination: {
                el: '.js-slider-pagination',
                dynamicBullets: true,
                clickable: true,
            },
            on: {
                slideChange: function() {
                    window.rm.location.sideEventHandler(this.slides[this.activeIndex])
                }
            }
        });
    }
}

$(document).on('response:point', initSlider)
